module.exports = __webpack_public_path__ + "media/melt.de8d7fef.webm";